import Vue from "vue";
import Router from "vue-router";
const Index = () => import("/page/index.vue");
const Login = () => import("/page/login.vue");
const signUpActivity = () => import("/page/signUpActivity.vue");
const Register = () => import("/page/register.vue");
const Forget = () => import("/page/forget.vue");
const AgreementPrivacy = () => import("/page/agreementPrivacy.vue");
const AgreementUser = () => import("/page/agreementUser.vue");
const Home = () => import("/page/Home/home.vue");
const Products = () => import("/page/product/allProducts.vue");
const productDetail = () => import("/page/trace/traceDetail.vue");
const seriesDetail = () => import("/page/series/seriesDetail.vue");
const suitDetail = () => import("/page/suit/suitDetail.vue");
const masterList = () => import("/page/master/masterList.vue");
const masterDetail = () => import("/page/master/masterDetail.vue");
const masterProduct = () => import("/page/master/masterProduct.vue");
const articleList = () => import("/page/article/articleList.vue");
const searchList = () => import("/page/product/searchList.vue");
const articleDetail = () => import("/page/article/articleDetail.vue");
const traceIndex = () => import("/page/trace/index.vue");
const seriesIndex = () => import("/page/series/index.vue");
const suitIndex = () => import("/page/suit/index.vue");
const traceCompany = () => import("/page/trace/traceCompany.vue");
const traceHistory = () => import("/page/trace/traceHistory.vue");
const traceDetail = () => import("/page/trace/traceDetail.vue");
const forumPlate = () => import("/page/forum/plate.vue");
const postDetail = () => import("/page/post/postDetail.vue");
const NotFound = () => import("/page/error/404.vue");
Vue.use(Router);
export default new Router({
  // mode: 'history',
  routes: [
    {
      path: "/",
      component: Index,
      name: "index",
      redirect: "/home",
      children: [
        { path: "home", component: Home },
        { path: "famous", component: Products },
        {
          path: "famous/detail",
          name: "productDetail",
          component: productDetail,
        },
        { path: "master", name: "masterList", component: masterList },
        {
          path: "master/detail",
          name: "masterDetail",
          component: masterDetail,
        },
        { path: "gongyi", name: "articleList", component: articleList },
        {
          path: "cup_knowledge/:classify",
          name: "baikeList",
          component: articleList,
        },
        { path: "search/:keyword", name: "searchList", component: searchList },
        { path: "zixun", name: "zixunList", component: articleList },
        {
          path: "cup_knowledge/:classify/article/detail/:id",
          name: "articleDetail",
          component: articleDetail,
        },
        {
          path: "/masterProduct/index",
          name: "masterProduct",
          component: masterProduct,
        },
        {
          path: "/forum/plate",
          name: "forumPlate",
          component: forumPlate,
          meta: {
            keepAlive: true,
          },
        },
        { path: "/product/index", name: "traceIndex", component: traceIndex },
        { path: "/suit/index", name: "suitIndex", component: suitIndex },
        { path: "/series/index", name: "seriesIndex", component: seriesIndex },
        {
          path: "/product/company",
          name: "traceCompany",
          component: traceCompany,
        },
        { path: "/history", name: "traceHistory", component: traceHistory },
        {
          path: "/product/detail",
          name: "traceDetail",
          component: traceDetail,
        },
        {
          path: "/series/detail",
          name: "seriesDetail",
          component: seriesDetail,
        },
        {
          path: "/suit/detail",
          name: "suitDetail",
          component: suitDetail,
        },
        {
          path: "/post/detail",
          name: "postDetail",
          component: postDetail,
        },
        // 未找到延迟加载pdfh5的方法，写多个页面
        {
          name: "pdfPageRawOre",
          path: "/pdfPageRawOre",
          component: () => import("/components/pdfPageRawOre.vue")
        },
        {
          name: "pdfPageGroup",
          path: "/pdfPageGroup",
          component: () => import("/components/pdfPageGroup.vue")
        },
        {
          name: "pdfPageLocal",
          path: "/pdfPageLocal",
          component: () => import("/components/pdfPageLocal.vue")
        },
        {
          name: "pdfPageTestReport",
          path: "/pdfPageTestReport",
          component: () => import("/components/pdfPageTestReport.vue")
        }
        // {
        //   name: "pdfPageRawOreFile",
        //   path: "/pdfPageRawOreFile",
        //   component: () => import("/assets/pdf/raw-ore.pdf")
        // },
        // {
        //   name: "pdfPageGroupFile",
        //   path: "/pdfPageGroupFile",
        //   component: () => import("/assets/pdf/TJYJZXH-1-2021.pdf")
        // },
        // {
        //   name: "pdfPageLocalFile",
        //   path: "/pdfPageLocalFile",
        //   component: () => import("/assets/pdf/DB35T-1739-2018.pdf")
        // }
      ],
    },
    {
      path: "/login",
      component: Login,
      name: "login",
    },
    {
      path: "/register",
      component: Register,
      name: "register",
    },
    {
      path: "/forget",
      component: Forget,
      name: "forget",
    },
    {
      path: "/signUpActivity",
      component: signUpActivity,
      name: "signUpActivity",
    },
    {
      path: "/agreementPrivacy",
      component: AgreementPrivacy,
      name: "agreementPrivacy",
    },
    {
      path: "/agreementUser",
      component: AgreementUser,
      name: "agreementUser",
    },
    {
      path: '*',
      component: NotFound, // 自定义的 404 页面组件
      name: 'NotFound'
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js